import { Navigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';

type LoginPageProps = {
  redirectTo?: string;
};

export function LoginPage({ redirectTo = '/' }: LoginPageProps) {
  const auth = useAuth();

  useEffect(() => {
    if (!auth.isLoading && !auth.isAuthenticated) {
      console.log('signinRedirect');
      void auth.signinRedirect({
        state: { redirectTo: redirectTo }
      });
    }
  }, [auth, redirectTo]);

  if (auth.error && !auth.isLoading) {
    return <div>{auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
    return <Navigate to={redirectTo} replace={true} />;
  }

  return <></>;
}
